import { render, staticRenderFns } from "./ProfileTableItem.vue?vue&type=template&id=0d8774e0&scoped=true&"
import script from "./ProfileTableItem.vue?vue&type=script&lang=ts&"
export * from "./ProfileTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileTableItem.vue?vue&type=style&index=0&id=0d8774e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8774e0",
  null
  
)

export default component.exports